import { useNavigate, useSearchParams } from 'react-router'
import { useSetAtom } from 'jotai'
import { omanSelectedShippingMethodAtom } from '../../../stores/oman.store'
import type { TOmanShippingMethodId } from '../../../types/oman.types'

export const useNavigateToShipping = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const setSelectedShippingMethod = useSetAtom(omanSelectedShippingMethodAtom)

    return (method?: TOmanShippingMethodId) => {
        const uuid = searchParams.get('uuid')
        if (method) setSelectedShippingMethod(method)
        navigate(uuid ? `/checkout/shipping?uuid=${uuid}` : '/checkout/shipping')
    }
}
